export const getFavicon = ({
  displayName,
  bucketBaseUrl,
}: {
  displayName: string;
  bucketBaseUrl: string;
}) => {
  const favicon =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  (favicon as HTMLLinkElement).type = "image/x-icon";
  (favicon as HTMLLinkElement).rel = "shortcut icon";
  (
    favicon as HTMLLinkElement
  ).href = `${bucketBaseUrl}/initiatives/${encodeURIComponent(
    displayName,
  )}/global/img/favicon.ico`;
  document.getElementsByTagName("head")[0].appendChild(favicon);
};
